import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function InitialBalanceDialog({ balForm, setBalForm, onSave }) {
  return (
    <Dialog open={!!balForm} onOpenChange={(o) => !o && setBalForm(null)}>
      <DialogContent className="max-w-sm" data-testid="initial-balance-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Saldo inicial de la cuenta</DialogTitle>
          <DialogDescription>El Cash Flow acumulará desde este saldo y fecha; los movimientos anteriores a esa fecha no se suman.</DialogDescription>
        </DialogHeader>
        {balForm && (
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs">Saldo (€)</Label>
              <Input data-testid="initial-balance-amount" type="number" step="0.01" value={balForm.initial_balance}
                onChange={(e) => setBalForm({ ...balForm, initial_balance: e.target.value })} className="h-9 font-num" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs">A fecha de</Label>
              <Input data-testid="initial-balance-date" type="date" value={balForm.initial_balance_date}
                onChange={(e) => setBalForm({ ...balForm, initial_balance_date: e.target.value })} className="h-9" />
            </div>
            <Button data-testid="initial-balance-save" onClick={onSave}
              disabled={balForm.initial_balance === "" || !balForm.initial_balance_date}
              className="w-full bg-[#D9381E] hover:bg-[#B91C1C] text-white">Guardar saldo inicial</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
